// extracted by mini-css-extract-plugin
export var active = "_sf-1";
export var circle = "_sf-0";
export var completed = "_sf-2";
export var connector = "_sf-4";
export var connectorCompleted = "_sf-7";
export var connectorSpacer = "_sf-5";
export var iconStrokeOverride = "_sf-8";
export var labelContainer = "_sf-6";
export var pending = "_sf-3";